<template>
  <span v-if="from && until">
    {{ $dayjs(from).format('DD.MM.YYYY.') }} -
    {{ $dayjs(until).format('DD.MM.YYYY.') }}
  </span>
  <span
    v-else-if="from"
  >
    from {{ $dayjs(from).format('DD.MM.YYYY.') }}
  </span>
  <span
    v-else-if="until"
  >
    until {{ $dayjs(until).format('DD.MM.YYYY.') }}
  </span>
  <span v-else>
    unlimited
  </span>
</template>
<script>
export default {
  name: 'DateRangeLabel',
  props: {
    from: {
      type: String,
      default: undefined
    },
    until: {
      type: String,
      default: undefined
    }
  }
}
</script>
